import React, { useState, useEffect } from "react";
import { Form, Segment, Label, Divider } from "semantic-ui-react";
import {
  setLocalidad,
  getLocalidad,
  setProvincia,
  getProvincia,
} from "../../utils/variablesLocales";
import { selecciona_localidad, continuar } from "../../utils/traductor";
import { apiLocalidad } from "../../api/localidad";
import Button from "@mui/material/Button";
import { Player } from "@lottiefiles/react-lottie-player";
import animacion from "../../imagenes/NuevoViaje/SeleccionaLocalidad.json";
import CheckIcon from "@mui/icons-material/Check";
import { ENTORNO } from "../../utils/constantes";

const apilocalidad = new apiLocalidad();

export function SeleccionaLocalidad({ Paso, setPaso }) {
  const [UrlApi, setUrlApi] = useState("");
  const [GeoLocalizacionCalculado, setGeoLocalizacionCalculado] = useState(0);
  const [IPPublica, setIPPublica] = useState("");
  const [LatLonGPS, setLatLonGPS] = useState("");
  const [LatLonIP, setLatLonIP] = useState("");
  const [LocalidadCalculada, setLocalidadCalculada] = useState("");

  const [localidads, setLocalidad1] =
    useState(
      null
    ); /*esta variable localidads, maneja el estado del item seleccionado en el combo localidad*/

  /*este es como el load de asp.net*/
  useEffect(() => {
    (async () => {
      try {
        //obtengo la lista de localidads para luego cargar el combo
        const response = await apilocalidad.obtener();

        setLocalidad1(response);

        //calculo geolocalizacion
        if (GeoLocalizacionCalculado === 0) {
          //calculo ip publica
          const ipPublica = require("react-public-ip");
          const ipv4 = (await ipPublica.v4()) || "";
          setIPPublica(ipv4);

          //calculo localidad y lat lon con ip publica
          setUrlApi(ENTORNO.Ping_IPtoLatLon1.replace("ipPublica", ipv4));

          const parametros = {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          };

          const respuesta = await fetch(
            ENTORNO.Ping_IPtoLatLon1.replace("ipPublica", ipv4),
            parametros
          );

          const respuestaJson = await respuesta.json();

          setLocalidadCalculada(respuestaJson.city);
          setLatLonIP(respuestaJson.loc);

          //calculo lat lon con GPS
          const onUbicacionConcedida = (ubicacion) => {
            setLatLonGPS(
              ubicacion.coords.latitude + ", " + ubicacion.coords.longitude
            );
          };

          const onErrorDeUbicacion = (err) => {
            setLatLonGPS("");
          };

          const opcionesDeSolicitud = {
            enableHighAccuracy: true, // Alta precisión
            maximumAge: 0, // No queremos caché
            timeout: 5000, // Esperar solo 5 segundos
          };

          // Solicitar
          navigator.geolocation.getCurrentPosition(
            onUbicacionConcedida,
            onErrorDeUbicacion,
            opcionesDeSolicitud
          );

          setGeoLocalizacionCalculado(1);
        }
      } catch (error) {
        console.error(error);
      }
    })();
  });

  ////////////////////////////////

  var localidadRegistros = [];

  if (localidads) {
    for (let i = 0; i < localidads.length; i++) {
      localidadRegistros.push({
        key: localidads[i].Nombre + ". " + localidads[i].ProvinciaEstado,
        text: localidads[i].Nombre + ". " + localidads[i].ProvinciaEstado,
        value: localidads[i].Nombre + ". " + localidads[i].ProvinciaEstado,
      });
    }
  }
  ////////////////////////////////

  return (
    <div>
      <Segment style={{ borderColor: "rgb(229, 246, 253)" }}>
        <Label
          attached="top"
          style={{
            backgroundColor: "rgb(229, 246, 253)",
            color: "rgb(1, 67, 97)",
          }}
        >
          {selecciona_localidad}
        </Label>
        <Form.Field>
          <Form.Dropdown
            name="localidad"
            placeholder={selecciona_localidad}
            value={getLocalidad() + ". " + getProvincia()}
            onChange={(_, data) => {
              setLocalidad(data.value.split(".")[0].trim());
              setProvincia(data.value.split(".")[1].trim());

              setPaso(1);
            }}
            fluid
            selection
            // options={localidadRegistros}

            options={[
              {
                key: "El Calafate. Santa Cruz",
                text: "El Calafate. Santa Cruz",
                value: "El Calafate. Santa Cruz",
              },
              {
                key: "Valencia. Valencia",
                text: "Valencia. Valencia",
                value: "Valencia. Valencia",
              },
              {
                key: "Córdoba. Córdoba",
                text: "Córdoba. Córdoba",
                value: "Córdoba. Córdoba",
              },
              {
                key: "Ushuaia. Tierra del Fuego",
                text: "Ushuaia. Tierra del Fuego",
                value: "Ushuaia. Tierra del Fuego",
              },
              {
                key: "Santiago del Estero",
                text: "Santiago del Estero",
                value: "Santiago del Estero",
              },
              {
                key: "Colonia Caroya",
                text: "Colonia Caroya",
                value: "Colonia Caroya",
              },
            ]}
          ></Form.Dropdown>
        </Form.Field>
        <div style={{ textAlign: "center" }}>
          <Button
            variant="contained"
            style={{
              background: "rgb(229, 246, 253)",
              color: "rgb(1, 67, 97)",
            }}
            onClick={() => {
              setPaso(1);
            }}
            startIcon={<CheckIcon />}
          >
            {continuar}
          </Button>
        </div>
        <br></br>
        <Player
          src={animacion}
          className="player"
          loop
          autoplay
          style={{ height: 130 }}
        />
        {/* <Divider></Divider>
        URL api: {UrlApi}
        <br></br>
        <br></br>
        Localidad calculada: {LocalidadCalculada}
        <br></br>
        <br></br>
        IP pública: {IPPublica}
        <br></br>
        <br></br>
        Lat Lon IP: {LatLonIP}
        <br></br>
        <br></br>
        Lat Lon GPS: {LatLonGPS} */}
      </Segment>
    </div>
  );
}
